(() => {
  'use strict';
  const configNode = document.getElementById('CataretteCatWeekConfig');
  if (!configNode) return;
  let config;
  try { config = JSON.parse(configNode.textContent); } catch (_) { return; }
  const start = Date.parse(config.start);
  const end = Date.parse(config.end);
  const valid = Number.isFinite(start) && Number.isFinite(end) && end > start;
  const root = document.documentElement;
  const stateAt = (now) => {
    if (!config.enabled || !valid) return 'off';
    if (config.editorPreview) return 'active';
    if (!config.ready) return 'off';
    if (now < start) return 'upcoming';
    if (now < end) return 'active';
    return 'ended';
  };
  const update = () => {
    const now = Date.now();
    const state = stateAt(now);
    if (root.dataset.ctCatweek !== state) {
      root.dataset.ctCatweek = state;
      document.dispatchEvent(new CustomEvent('catarette:catweek-state', { detail: { state } }));
    }
    const target = state === 'upcoming' ? start : end;
    const remaining = Math.max(0, target - now);
    const canCount = (state === 'active' || state === 'upcoming') && remaining > 0;
    const days = Math.floor(remaining / 86400000);
    const hours = Math.floor(remaining / 3600000) % 24;
    const minutes = Math.floor(remaining / 60000) % 60;
    document.querySelectorAll('[data-ct-cw-clock]').forEach((clock) => {
      clock.hidden = !canCount;
      if (!canCount) return;
      [['days', days], ['hours', hours], ['minutes', minutes]].forEach(([unit, value]) => {
        const node = clock.querySelector('[data-ct-cw-' + unit + ']');
        const text = String(value).padStart(2, '0');
        if (node && node.textContent !== text) node.textContent = text;
      });
    });
  };
  update();
  const interval = window.setInterval(update, 1000);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) update(); });
  document.addEventListener('shopify:section:load', update);
  document.addEventListener('cart:change', update);
  document.addEventListener('cart:refresh', update);
  window.addEventListener('pageshow', update);
  window.addEventListener('pagehide', (event) => { if (!event.persisted) window.clearInterval(interval); });
})();
